import { useQuery } from "@tanstack/react-query";
import { getProjectLabels } from "../api/getProjectLabels";

export const useGetProjectLabelsQuery = (projectUuid: string | undefined) => {
  return useQuery({
    queryKey: ["project-labels", projectUuid],
    queryFn: () => {
      if (!projectUuid) {
        return Promise.resolve([]);
      }
      return getProjectLabels(projectUuid);
    },
    enabled: !!projectUuid,
  });
};
